enum NodeRuleConditions {
  FieldReturnsAUserValue = 0,
  FieldReturnsATeamValue = 1
}

export default NodeRuleConditions;
